import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import { AdminPanelService } from '../../../data/admin-panel.service';
import { SystemDictionary } from '../../../data/system-dictionary';

@Component({
  selector: 'app-dictionary-editor-dialog',
  templateUrl: './dictionary-editor-dialog.component.html',
  styleUrls: ['./dictionary-editor-dialog.component.scss']
})
export class DictionaryEditorDialogComponent implements OnInit {
  saveLoading = false;

  tempDict: SystemDictionary

  constructor(
    protected dialogRef: MatDialogRef<DictionaryEditorDialogComponent>,
    protected adminPanelService: AdminPanelService,
    private miscSnackBarService: MiscSnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: {
      dictionary: SystemDictionary
    }
  ) {
  }

  ngOnInit(): void {
    this.tempDict = Object.assign({}, this.data.dictionary)
    this.tempDict.color = '#' + this.tempDict.color
  }

  saveDict() {
    this.saveLoading = true;

    this.tempDict.color = this.tempDict.color.substring(1);

    this.adminPanelService.saveSystemDictionary(this.tempDict).subscribe(newDict => {
      this.miscSnackBarService.openSuccessSnackBar('Success!')

      this.dialogRef.close(newDict);
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.saveLoading = false;
    })
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }
}
